<template>
<a class="gi-card" :href="data.link" target="_blank">
  <div class="image"><img :src="data['图片']"></div>
  <div class="content">
    <h1 class="title">{{data.title}}</h1>
    <p class="intro">{{data.description}}</p>
    <p class="tip">{{data.tip}}</p>
  </div>
</a>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"
$title-primary: #1075d4

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

a.gi-card:hover
  opacity: 0.8
.gi-card
  display: flex
  flex-flow: row nowrap
  align-items: flex-start
  +mobile
    align-items: center
  .image
    width: 35vw
    margin: 15px 0 0 10px
    +mobile
      margin: 0 0 0 5px
    img
      border-radius: 5px
      width: 100%
  .content
    background-color: #fff
    padding: 15px
    width: 55vw
  h1
    font-size: 18px
    color: #000
    line-height: 20px
    height: 40px
    overflow: hidden
    display: -webkit-box
    text-overflow: ellipsis
    -webkit-line-clamp: 2
    /*! autoprefixer: off */
    -webkit-box-orient: vertical
    /*! autoprefixer: on */
    +mobile
      font-size: 16px
  .intro
    margin-top: 5px
    font-size: 14px
    overflow: hidden
    height: 60px
    text-overflow: ellipsis
    -webkit-line-clamp: 3
    display: -webkit-box
    /*! autoprefixer: off */
    -webkit-box-orient: vertical
    /*! autoprefixer: on */
    +widescreen
      height: 80px
      -webkit-line-clamp: 4
    &:after
      content: '...'
  .tip
    color: #007df3
    margin-top: 15px
    font-size: 12px
    // &:after
      content: '>>'
    +mobile
      margin-top: 15px
</style>



// WEBPACK FOOTER //
// src/components/card3/card.vue